module.exports = __webpack_public_path__ + "img/G9.837c985f.png";